module.exports = __webpack_public_path__ + "static/media/menu.3fed1053.svg";